import { ENV_CONFIG } from '../../config/env';

export class NetworkHelper {
  // Ağ durumu
  private static isOnline: boolean = true;

  // Network yapılandırma
  private static setupDone: boolean = false;

  // Network yapılandırmasını kur
  static setupNetworkConfig(): void {
    if (this.setupDone) return;

    // Tarayıcının online/offline durumunu dinleme
    window.addEventListener('online', () => {
      console.log('[NetworkHelper] Browser online');
      NetworkHelper.isOnline = true;
    });
    
    window.addEventListener('offline', () => {
      console.log('[NetworkHelper] Browser offline');
      NetworkHelper.isOnline = false;
    });

    // Başlangıç durumunu ayarla
    this.isOnline = navigator.onLine;
    this.setupDone = true;
    
    console.log(`[NetworkHelper] Initial network state: ${this.isOnline ? 'Online' : 'Offline'}`);
  }

  // Ağ durumunu logla
  static logNetworkConfig(): void {
    console.log({
      online: this.isOnline,
      apiGatewayUrl: ENV_CONFIG.apiGatewayUrl,
      appEnv: ENV_CONFIG.appEnv,
      isDevelopment: ENV_CONFIG.isDevelopment,
      isProduction: ENV_CONFIG.isProduction
    });
  }

  // Network durumunu öğren
  static isNetworkConnected(): boolean {
    return this.isOnline;
  }

  // API ile ilgili yapılandırmaları al
  static getApiConfig() {
    return {
      apiTimeout: ENV_CONFIG.isDevelopment ? 30000 : 15000, // Geliştirme ortamında daha uzun timeout
      enableDebug: !ENV_CONFIG.isProduction // Üretim ortamında debug kapalı
    };
  }

  // Request/fetch yapılandırması
  static getPlatformSpecificFetchConfig(): Record<string, any> {
    return {
      cache: 'no-cache',
      credentials: 'same-origin',
      keepalive: false,
      headers: {}
    };
  }
} 